
import { useEffect } from "react";
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";
import { AuthCheck } from "@/components/auth/AuthCheck";
import ProgramCreationManager from "@/components/programs/ProgramCreationManager";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { useLocation } from "react-router-dom";
import { useProgramCreation } from "@/contexts/ProgramCreationContext";

export default function CreateProgram() {
  const storedAvatar = localStorage.getItem('userAvatar') || "/placeholder.svg";
  const storedName = localStorage.getItem('userName') || "Coach";
  const { refreshPermissions } = usePermissionCheck();
  const location = useLocation();
  const { resetSession } = useProgramCreation();

  useEffect(() => {
    // Refresh permissions when the page loads
    refreshPermissions();
    
    // Check if we're coming to this page with a reset param
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('reset') === 'true') {
      resetSession();
    }
  }, [refreshPermissions, location.search, resetSession]);

  return (
    <AuthCheck>
      <BackgroundGradientAnimation>
        <div className="flex flex-col h-screen">
          <Header avatar={storedAvatar} name={storedName} />
          <div className="flex flex-1 overflow-hidden">
            <Sidebar />
            <main className="flex-1 overflow-y-auto px-4 py-6">
              <ProgramCreationManager />
            </main>
          </div>
        </div>
      </BackgroundGradientAnimation>
    </AuthCheck>
  );
}
